import { createSlice } from "@reduxjs/toolkit";
import { getAllPacksAction, getAllVideosAction, getPackDetailsAction, getRequestedPacksAction } from "../Action/AddOnPackAction";

const AddOnPackSlice = createSlice({
  name: "AddOnPack",
  initialState: {
    packs: {},
    requests: {},
    videos: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllPacksAction.fulfilled, (state, action) => {
      state.packs = action?.payload?.data;
    });
    builder.addCase(getRequestedPacksAction.fulfilled, (state, action) => {
      state.requests = action?.payload?.data;
    });
    builder.addCase(getPackDetailsAction.fulfilled, (state, action) => {
      state.packs = action?.payload?.data;
    });
    builder.addCase(getAllVideosAction.fulfilled, (state, action) => {
      state.videos = action?.payload?.data;
    });
  },
});

export default AddOnPackSlice.reducer;
